// Revisión manual contra Zentral de catálogo e inventario en `retail-catalog-business` («Actualizar»).
import type { GetCatalogReconciliationResponse } from '@fiado/type-kit/bin/retailIntegration/dtos/GetReconciliationResponses';
import type {
    StartCatalogReconciliationRequest,
    StartCatalogReconciliationResponse,
} from '@fiado/type-kit/bin/retailIntegration/dtos/StartCatalogReconciliationRequest';
import { apiFetch } from '../../client';

const BASE_URL = import.meta.env.VITE_API_RETAIL_CATALOG_BASE_URL;

export type { GetCatalogReconciliationResponse };

/** Cuerpo del arranque; `storeId` solo aplica a inventario y `dryRun` solo calcula la vista previa. */
export type StartCatalogReconciliationInput = Pick<
    StartCatalogReconciliationRequest,
    'entity' | 'storeId' | 'dryRun'
>;

/** `backofficeStartCatalogReconciliation` — 202 con el runId; 409 trae en `data.runId` la que ya corre. */
export function startCatalogReconciliation(
    retailerId: string,
    input: StartCatalogReconciliationInput,
): Promise<StartCatalogReconciliationResponse> {
    return apiFetch<StartCatalogReconciliationResponse>(
        `/backoffice/retailers/${retailerId}/reconciliations`,
        { method: 'POST', body: JSON.stringify(input), baseUrl: BASE_URL },
    );
}

/** `backofficeGetCatalogReconciliation` — estado, páginas, conteos y tiendas pendientes. */
export function getCatalogReconciliation(
    retailerId: string,
    runId: string,
): Promise<GetCatalogReconciliationResponse> {
    return apiFetch<GetCatalogReconciliationResponse>(
        `/backoffice/retailers/${retailerId}/reconciliations/${runId}`,
        { baseUrl: BASE_URL },
    );
}
